// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1zptF","buttons":"Footer_buttons__1fDRP"};